export const AIRING_TODAY = 'airing_today'
export const ON_THE_AIR = 'on_the_air'
export const POPULAR_TV = 'popular'
export const TOP_RATED_TV = 'top_rated'
